module.exports = __webpack_public_path__ + "static/img/logo.faa5948.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/logo.png
// module id = rHQ1
// module chunks = 1